import React from 'react';
import Success from '../assets/images/Success-Alt.svg';

export default () => {
  return <img src={Success} alt="success" />;
};
